import produce from 'immer';
import { actionTypes as dateRangePickerActionTypes, reducerValuesFunction as dateRangePickerReducerFunction } from '@components/Kendo/DateRangePickerReducer';
export const actionTypes = Object.assign({ LOADING_CHANGED: 'LOADING_CHANGED', DATA_LOADED: 'DATA_LOADED', DATA_CHANGED: 'DATA_CHANGED', PAGE_CHANGED: 'PAGE_CHANGED', SORT_CHANGED: 'SORT_CHANGED', FILTER_CHANGED: 'FILTER_CHANGED', FILTER_TOGGLED: 'FILTER_TOGGLED', COLUMNS_CHANGED: 'COLUMNS_CHANGED' }, dateRangePickerActionTypes // static line, should be the only one for all DateRangePickers
);
export const reducer = produce((draft, action) => {
    // static snippet, should be the only one for all DateRangePickers
    if (Object.keys(dateRangePickerActionTypes).includes(action.type)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        dateRangePickerReducerFunction(draft, action);
        return;
    }
    switch (action.type) {
        case actionTypes.LOADING_CHANGED:
            if (action.type === 'LOADING_CHANGED') {
                draft.loading = action.loading;
            }
            break;
        case actionTypes.DATA_LOADED:
            if (action.type === 'DATA_LOADED') {
                draft.data = action.data.data;
                draft.totalCount = action.data.total;
                draft.loading = false;
            }
            break;
        case actionTypes.DATA_CHANGED:
            if (action.type === 'DATA_CHANGED') {
                draft.data = action.data;
            }
            break;
        case actionTypes.PAGE_CHANGED:
            if (action.type === 'PAGE_CHANGED') {
                draft.page = action.page;
            }
            break;
        case actionTypes.SORT_CHANGED:
            if (action.type === 'SORT_CHANGED') {
                draft.sort = action.sort;
            }
            break;
        case actionTypes.FILTER_CHANGED:
            if (action.type === 'FILTER_CHANGED') {
                draft.filters = action.filters;
            }
            break;
        case actionTypes.FILTER_TOGGLED:
            if (action.type === 'FILTER_TOGGLED') {
                draft.filters.active[action.field] = !draft.filters.active[action.field];
                draft.filters.values[action.field] = '';
            }
            break;
        case actionTypes.COLUMNS_CHANGED:
            if (action.type === 'COLUMNS_CHANGED') {
                draft.columns = action.columns;
            }
            break;
        default:
            // No error throwing in TypeScript version, just return unchanged state
            break;
    }
});
